import React from 'react';
import { LabelLarge } from 'baseui/typography';
export function MLAnnotationsHeader() {
  return <LabelLarge margin={0}>ML Annotations</LabelLarge>;
}